import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
var toLocalBounds = gmapBounds => ({
  from: {
    lat: gmapBounds.nw.lat,
    lon: gmapBounds.nw.lng
  },
  to: {
    lat: gmapBounds.se.lat,
    lon: gmapBounds.se.lng
  }
});
var toLocalCenter = gmapCenter => ({
  lat: gmapCenter.lat,
  lon: gmapCenter.lng
});
var toGMapBounds = localBounds => ({
  nw: {
    lat: localBounds.from.lat,
    lng: localBounds.from.lon
  },
  se: {
    lat: localBounds.to.lat,
    lng: localBounds.to.lon
  }
});
var toGMapCenter = localCenter => ({
  lat: localCenter.lat,
  lng: localCenter.lon
});
var boundsToCenter = bounds => bounds && {
  lat: (bounds.from.lat + bounds.to.lat) / 2,
  lon: (bounds.from.lon + bounds.to.lon) / 2
};

// Following 2 functions taken from
// https://github.com/domain-group/fe-pa-map-search/blob/master/src/js/utils/geospatial.js
var EARTH_RADIUS = 6378137;
var GOOGLE_MAP_TILE_SIZE = 256;
var pixelToMapMeters = (lat, zoom, pixels) => {
  var zoomOffset = GOOGLE_MAP_TILE_SIZE * 2 ** zoom; // eslint-disable-line no-restricted-properties
  var resolution = Math.cos(lat * (Math.PI / 180)) * 2 * Math.PI * EARTH_RADIUS / zoomOffset;
  return resolution * pixels;
};
var approximateAddMetersToPoint = (point, deltaX, deltaY) => {
  var lat = point.lat + deltaY / EARTH_RADIUS * (180 / Math.PI);
  var lon = point.lon + deltaX / EARTH_RADIUS * (180 / Math.PI) / Math.cos(point.lat * (Math.PI / 180));
  return {
    lat,
    lon
  };
};
var centerToBounds = (center, zoom, meters) => {
  var deltaX = pixelToMapMeters(center.lon, zoom, -meters);
  var deltaY = pixelToMapMeters(center.lat, zoom, meters);
  return approximateAddMetersToPoint(center, deltaX, deltaY);
};
var listingToMarkers = function listingToMarkers(searchResults) {
  var clusteredResults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var markers = [];
  searchResults.forEach(item => {
    if (item.address && item.address.coordinates && item.address.coordinates.lat && item.address.coordinates.lon) {
      markers.push({
        lat: item.address.coordinates.lat,
        lng: item.address.coordinates.lon,
        isFeatured: !!get(item.listing, 'badges.featuredProperty') || !!get(item.listing, 'badges.propertyOfTheWeek') || !!get(item.listing, 'badges.topSpot'),
        markerKey: item.listing.id,
        listings: [item]
      });
    }
  });
  clusteredResults.forEach(item => {
    if (item.coordinates && item.coordinates.lat && item.coordinates.lon) {
      markers.push({
        markerKey: item.items.map(subitem => subitem.listing.id).join('+'),
        count: item.count,
        lat: item.coordinates.lat,
        lng: item.coordinates.lon,
        isFeatured: !!get(item.badges, 'featured') || !!get(item.badges, 'propertyOfTheWeek') || !!get(item.badges, 'topSpot'),
        listings: item.items
      });
    }
  });
  return markers;
};
var centroidToCenter = localities => {
  var locality = isEmpty(localities) ? null : localities[0];
  return locality && locality.centroid ? {
    lat: locality.centroid.latitude,
    lon: locality.centroid.longitude
  } : null;
};
export default {
  boundsToCenter,
  centerToBounds,
  listingToMarkers,
  approximateAddMetersToPoint,
  pixelToMapMeters,
  toLocalBounds,
  toGMapBounds,
  toGMapCenter,
  toLocalCenter,
  centroidToCenter
};